import { Flex, Spinner, Text, View, Pill } from '@smarterservices/smarter-ui';
import { usePlayerStore } from '../../../stores/StoreContext';
import { Case } from 'change-case-all';
import ReadableTime from '../../Common/ReadableTime';
import CONSTANTS from '../../../config/constants';

const Disconnected = ({ SessionTrack }) => {
    const overlay = usePlayerStore((state) => state.overlay);
    const isLive = usePlayerStore((state) => state.isLive);
    const currentTime = usePlayerStore((state) => state.currentTime);
    const jumpTo = usePlayerStore((state) => state.jumpTo);
    const displayVideoLabels = usePlayerStore((state) => state.displayVideoLabels);

    const JUMP_TO_CONNECTION_TIME_OFFSET = 0;

    if (overlay === CONSTANTS.OVERLAYS.PLAYBACK_COMPLETE && !isLive) {
        return null;
    }

    // Find the next 'online' status after current time to determine when track will reconnect
    let reconnectionTime = null;
    if (SessionTrack?.hls?.track?.statuses) {
        const nextOnlineStatus = SessionTrack.hls.track.statuses.find(
            status => status.status === 'online' && status.sessionChangeTime > currentTime
        );
        if (nextOnlineStatus) {
            reconnectionTime = nextOnlineStatus.sessionChangeTime;
        }
    }

    // Calculate time until reconnection
    const timeUntilReconnection = reconnectionTime !== null ? reconnectionTime - currentTime : null;

    const handleJumpToReconnection = () => {
        if (reconnectionTime !== null) {
            // Jump to 5 seconds before reconnection time
            const targetTime = Math.max(0, reconnectionTime - JUMP_TO_CONNECTION_TIME_OFFSET);
            jumpTo(targetTime);
        }
    };

    return (
        <Flex
            direction="column"
            alignItems="center"
            justifyItems="center"
            height="100%"
        >
            <View as="div" textAlign="center">
                {displayVideoLabels === 'hide' &&
                    <View as="div" margin="none none small none">
                        <Text as="p" textAlign="center" variant="contentImportant" color="primary-inverse">
                            {Case.capital(SessionTrack.name)}
                        </Text>
                    </View>
                }
                <Text as="p" textAlign="center" size="x-small" color="primary-inverse">
                    Stream Disconnected
                </Text>
                {!isLive && timeUntilReconnection !== null && timeUntilReconnection > 0 ? (
                    <View as="div" margin="small none none">
                        <Text as="p" textAlign="center" size="x-small" color="primary-inverse">
                            Reconnects in <ReadableTime seconds={timeUntilReconnection} />
                        </Text>
                        {/* Force this not to show for now. */}
                        {(timeUntilReconnection > 5 && 0 === 1) && (
                            <View as="div" margin="small none none none" textAlign="center">
                                <Pill
                                    color="primary"
                                    onClick={handleJumpToReconnection}
                                    cursor="pointer"
                                >
                                    <Text variant="legend">Jump To Time</Text>
                                </Pill>
                            </View>
                        )}
                    </View>
                ) : (reconnectionTime === null && !isLive) && (
                    <View as="div" margin="small none none">
                        <Text as="p" textAlign="center" size="x-small" color="primary-inverse">
                            Disconnected for remainder of session
                        </Text>
                    </View>
                )}
            </View>
        </Flex>
    );
}
export default Disconnected;